import { IChannelPermission } from 'community/types/Permissions';
import { ITime } from 'blackFriday/types/Time';

export enum PubNubActions {
  setPubNubAuth = 'setPubNubAuth',
  setNotification = 'setNotification',
}
export interface IPubNubActions {
  type: PubNubActions;
  payload: string;
}

export interface IPubNubAuthAction {
  type: PubNubActions;
  payload: {
    authorizedUuid: string | null;
    channelsWithPermissionsList: IChannelPermission[] | null;
    expiresOn: ITime | null;
    pubNubToken: string | null;
  };
}

export interface IPubNubNotificationAction {
  type: PubNubActions;
  payload: string;
}

type IPubNubStateAction =
  | {
      type: PubNubActions.setPubNubAuth;
      payload: {
        authToken: string | null;
        authorizedUuid: string | null;
        channelsWithPermissionsList: IChannelPermission[] | null;
        expiresOn: ITime | null;
      };
    }
  | { type: PubNubActions.setNotification; payload: string };

export type IPubNubDispatch = (action: IPubNubStateAction) => void;

export interface IPubNubState {
  authorizedUuid: string | null;
  channelsWithPermissionsList: IChannelPermission[] | null;
  expiresOn: ITime | null;
  pubNubToken: string | null;
  namespace: string | null | undefined;
  notification: string | null;
}

export const INITIAL_COMMUNITY_STATE = {
  authorizedUuid: null,
  channelsWithPermissionsList: null,
  expiresOn: null,
  pubNubToken: null,
  namespace: null,
  notification: null,
};

export const pubNubReducer = (state: IPubNubState, action: IPubNubStateAction) => {
  switch (action.type) {
    case PubNubActions.setPubNubAuth:
      // eslint-disable-next-line no-case-declarations
      const {
        authToken = null,
        authorizedUuid = null,
        channelsWithPermissionsList = null,
        expiresOn = null,
      } = action.payload || {};
      state.pubNubToken = authToken;
      state.authorizedUuid = authorizedUuid;
      state.channelsWithPermissionsList = channelsWithPermissionsList;
      state.expiresOn = expiresOn;
      break;
    case PubNubActions.setNotification:
      state.notification = action.payload;
      break;
    default:
      return state;
  }
  return state;
};
